export const LOGO_POSITION = {
  top: "top",
  bottom: "bottom",
} as const;
